import React from "react";
import { Button, Icon } from "../../components/tailwind";

type Props = {
  hasEnrichResults: boolean;
  onEnrich: () => void;
  isEnriching: boolean;
  isJobActive: boolean;
  hasSelectedFields: boolean;
  selectedFieldset: number | null;
  isFileInvalid: boolean;
  onSendToPim: () => void;
  latestJobUrl: string | null;
  hasSelectedSendableFields: boolean;
  isSendingToPim: boolean;
};

export const EnrichViewHeader: React.FC<Props> = ({
  hasEnrichResults,
  onEnrich,
  isEnriching,
  isJobActive,
  hasSelectedFields,
  selectedFieldset,
  isFileInvalid,
  onSendToPim,
  latestJobUrl,
  hasSelectedSendableFields,
  isSendingToPim,
}) => (
  <div className="tw-border-t tw-border-gray-200 tw-p-4 tw-pt-2">
    <div className="tw-flex tw-justify-between tw-items-start tw-flex-wrap tw-gap-4">
      <div className="tw-flex-1 tw-min-w-0">
        {hasEnrichResults ? (
          <>
            <p className="tw-text-lg tw-font-semibold tw-text-gray-900 tw-my-0 tw-py-0">
              Enrich Result
            </p>
            <p className="tw-text-gray-500 tw-text-sm tw-my-0 tw-py-0">
              AI-generated product fields with enriched data, values, and
              reasoning based on available information.
            </p>
          </>
        ) : (
          <>
            <p className="tw-text-lg tw-font-semibold tw-text-gray-900 tw-my-0 tw-py-0">
              Fields
            </p>
            <p className="tw-text-gray-500 tw-text-sm tw-my-0 tw-py-0">
              No Enrich results yet
            </p>
          </>
        )}
        {latestJobUrl ? (
          <p className="tw-text-sm tw-my-0 tw-py-0">
            <a
              href={latestJobUrl}
              target="_blank"
              rel="noreferrer"
              className="tw-text-blue-600 hover:tw-underline"
            >
              Job details...
            </a>
          </p>
        ) : null}
      </div>
      <div className="tw-flex tw-gap-2">
        {hasEnrichResults ? (
          <Button
            variant="textual-blue-alt"
            size="sm"
            compact="very"
            className="tw-h-8"
            onClick={onEnrich}
            disabled={
              !selectedFieldset ||
              isEnriching ||
              isJobActive ||
              !hasSelectedFields ||
              isFileInvalid
            }
            data-testid="enrich-again-button"
          >
            {isEnriching ? (
              "Enriching..."
            ) : (
              <span className="tw-flex tw-items-center tw-gap-2">
                <Icon name="auto_fix_high" /> Enrich again
              </span>
            )}
          </Button>
        ) : (
          <Button
            variant="textual-blue"
            onClick={onEnrich}
            size="sm"
            compact
            disabled={
              !selectedFieldset ||
              isEnriching ||
              isJobActive ||
              !hasSelectedFields ||
              isFileInvalid
            }
            data-testid="enrich-button"
          >
            {isEnriching ? (
              "Enriching..."
            ) : (
              <span className="tw-flex tw-items-center tw-gap-2">
                <Icon name="auto_fix_high" />
                Enrich
              </span>
            )}
          </Button>
        )}
        <Button
          variant="textual-blue"
          size="sm"
          compact="very"
          className="tw-h-8"
          onClick={() => onSendToPim()}
          disabled={
            !hasEnrichResults || !hasSelectedSendableFields || isJobActive
          }
          data-testid="send-to-pim-button"
          loading={isSendingToPim}
        >
          <span className="tw-flex tw-items-center tw-gap-2">
            <Icon name="send" /> Send to PIM
          </span>
        </Button>
      </div>
    </div>
  </div>
);
